import styled from 'styled-components';
import * as palette from '@mlc/mlc-palette';
import { ScreenSize } from '../../../../enums';

export const UserSiteTools = styled.button`
	&:hover,
	&:focus {
		background-color: ${palette.mlcDeepAqua};
		color: ${palette.mlcWhite};
		text-decoration: underline;
	}

	align-items: center;
	background-color: ${palette.mlcAqua};
	border: none;
	color: ${palette.mlcWhite};
	display: flex;
	height: 50px;
	outline: 0;
	padding-left: 10px;
	padding-right: 10px;
	text-align: left;
	text-decoration: none;

	& > div {
		margin-right: 10px;
	}
`;

export const AdvisorNameText = styled.span`
	font-size: 16px;
	margin-top: 1px;

	@media (max-width: ${ScreenSize.small}) {
		border: 0;
		clip: rect(0, 0, 0, 0);
		height: 1px;
		margin: -1px;
		overflow: hidden;
		padding: 0;
		position: absolute;
		width: 1px;
	}
`;
